import { Link } from 'react-router-dom';
import type { BlogArticle } from '@/mocks/blog';

interface ArticleCardProps {
  article: BlogArticle;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-accent-300/60 transition-all duration-300 flex flex-col">
      <Link to={`/blog/${article.slug}`} className="block overflow-hidden">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={article.image}
            alt={article.imageAlt}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          {article.isPremium && (
            <span className="absolute top-3 right-3 bg-accent-500 text-foreground-950 text-xs font-label font-medium px-2.5 py-1 rounded-full flex items-center gap-1">
              <i className="ri-lock-line text-xs" />
              Premium
            </span>
          )}
        </div>
      </Link>

      <div className="p-5 flex flex-col flex-1">
        <div className="flex items-center gap-3 mb-2.5">
          <span className="text-xs font-label font-medium text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full">
            {article.categoryLabel}
          </span>
          <span className="text-xs font-label text-foreground-500">
            {article.readTime}
          </span>
        </div>

        <Link to={`/blog/${article.slug}`} className="block group/title">
          <h3 className="font-heading font-semibold text-lg mb-2 text-primary-500 group-hover/title:text-primary-600 transition-colors leading-snug">
            {article.title}
          </h3>
        </Link>

        <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1 font-body">
          {article.excerpt}
        </p>

        <div className="flex items-center justify-between pt-3 border-t border-background-200/70">
          <span className="text-xs font-label text-foreground-500">
            {new Date(article.date).toLocaleDateString('en-GB', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            })}
          </span>
          <Link
            to={`/blog/${article.slug}`}
            className="text-sm font-label font-medium text-secondary-500 hover:text-secondary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            Read more
            <i className="ri-arrow-right-line text-xs" />
          </Link>
        </div>
      </div>
    </article>
  );
}